/**
 * 회원 포인트 응답의 usePolicy.maxUseRules 로 이 결제의 최대 사용 포인트를 구한다.
 * 백엔드 PointTransactionService.resolveMaxUsablePoint 와 같은 규칙이다.
 * 규칙이 여러 개면(여러 회원 그룹) 한도가 큰 값을 쓰고, 없으면 상한 없음(Infinity)이다.
 *
 * @param {{maxUseType: 'FIXED'|'PERCENT', maxUseValue: number}[]} rules
 * @param {number} paymentAmount 포인트 차감 전 결제금액
 */
export const resolveMaxUsableByRules = (rules, paymentAmount) => {
  if (rules.length === 0) return Infinity;
  return Math.max(
    ...rules.map(rule =>
      rule.maxUseType === 'FIXED'
        ? rule.maxUseValue
        : Math.floor(((Number(paymentAmount) || 0) * rule.maxUseValue) / 100),
    ),
  );
};

/** 회원 정책이 아직 없을 때(조회 전) 쓰는 지점 설정 규칙. */
export const branchMaxUseRules = setting =>
  setting?.maxUseType && setting?.maxUseValue != null
    ? [{ maxUseType: setting.maxUseType, maxUseValue: setting.maxUseValue }]
    : [];
